import { type IContainer } from 'bottlejs'
import type { MultiBindingService } from './MultiBindingService'
import type { DiId } from '@/common/di/di-ids'

export class NonLazyCreateService {
  constructor(
    private container: IContainer<DiId>,
    private multiBindingService: MultiBindingService<DiId>,
  ) {}

  public createAll() {
    const bindIds = this.multiBindingService.multiIdToIds['INonLazyCreate']!
    for (const bindId of bindIds) {
      void this.container[bindId]
    }
  }
}
